import { ApiError, handleApiError } from '@/handleApiError'
import api from '@/modules/authentication/api'
import { Step } from '@/modules/authentication/types'
import { t } from '@/plugins/i18n.ts'
import router from '@/router'
import { EmailStatus, SelfInvite, SelfRegistration } from '@/types/index'
import { defineStore } from 'pinia'

interface SelfRegistrationState {
  sending: boolean
}

const initialState = (): SelfRegistrationState => {
  return {
    sending: false
  }
}

const useSelfRegistration = defineStore('selfRegistration', {
  state: () => initialState(),
  actions: {
    async validateEmail(email: string): Promise<EmailStatus | void> {
      this.sending = true

      return api
        .validateRegistrationEmail(email)
        .then(({ data }) => data)
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.invitation')
          })
        })
        .finally(() => (this.sending = false))
    },
    async requestRegistrationEmail(data: SelfInvite) {
      this.sending = true

      return api.selfInvite(data).finally(() => (this.sending = false))
    },
    async requestSelfRegistration(data: SelfRegistration, setStepCallback: (step: Step) => void) {
      this.sending = true

      return api
        .executeSelfRegistration(data)
        .then(() => {
          router.replace({
            name: 'SelfRegistration',
            params: { step: Step.REQUESTED }
          })
          setStepCallback(Step.REQUESTED)
        })
        .catch((error: ApiError) => {
          handleApiError(error, {
            customMessage: t('error.registration')
          })
        })
        .finally(() => (this.sending = false))
    }
  }
})

export default useSelfRegistration
